// Clerk mounts its invisible bot-protection challenge here when enabled — without this element,
// signIn.create()/signUp.create() has nowhere to render it and just hangs. `empty:hidden`
// collapses the gap this flex child would otherwise reserve when Clerk leaves it empty.
export function AuthCaptcha() {
  return <div id="clerk-captcha" className="empty:hidden" />;
}
